module.exports = __webpack_public_path__ + "media/images/rotate-camera-da1b098df032fadeffc48fe39ad13493.png";